import axios from "axios";

export const postDetailsKonfirmasi = async (formData) => {
  return await axios.post(
    `${process.env.VUE_APP_API_URL}/etle/api/details_konfirmasi.php`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const postKonfirmasiPelanggar = async (formData) => {
  return await axios.post(
    `${process.env.VUE_APP_API_URL}/etle/api/konfirmasi_pelanggar.php`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

// export const postKonfirmasiLitsus = async (id, status) => {
//   return axios.post(
//     `${process.env.VUE_APP_API_URL}/etle/admin-etle/litsus.php`,
//     {
//       id,
//       status,
//     }
//   );
// };

export const postKonfirmasiLitsus = async (formData) => {
  return axios.post(
    `${process.env.VUE_APP_API_URL}/etle/admin-etle/litsus.php`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const masterPendidikanPekerjaan = async (formData) => {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}/etle/admin-etle/m_pendidikan_pekerjaan.php`,
    formData,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const getConfirmationType = async () => {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}/etle/api/confirmation_type.php`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const getImgCrossOrigin = async (url_img) => {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}/etle/admin-etle/getImage.php?imageUrl=` +
      url_img,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const getProxyImg = async (url_img) => {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}/etle/admin-etle/proxy-image.php?url=` +
    encodeURIComponent(url_img),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const getPenerbitanBriva = async (
  reffNumber,
  platNumber
) => {
  return axios.get(
    `${process.env.VUE_APP_API_URL}/etle/admin-etle/penerbitan_briva.php`,
    {
      params: {
        reff_number: reffNumber,
        plat_number: platNumber,
      },
    }
  );
};


